module.exports = __webpack_public_path__ + "img/IMG_20191125_195909.aeefff3b.jpg";